import {appApi} from "./api.service";
import {Preferences} from "@capacitor/preferences";
import {Geolocation} from "@capacitor/geolocation";
import {LocationQrData} from "@modals/location/location.component";

let endpointPrefix = 'localization';

export const getNearestClients = async () => {
    const coordinates = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 0
    });
    console.log(coordinates.coords)
    return appApi.get(endpointPrefix + '/nearest-clients', {
        params: {
            latitude: coordinates.coords.latitude,
            longitude: coordinates.coords.longitude,
        }
    });
}

export const postConfirmClient = async (clientId: bigint) => {
    const coordinates = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 0
    });
    return appApi.post(endpointPrefix + '/' + clientId + '/confirm-client', {
        latitude: coordinates.coords.latitude,
        longitude: coordinates.coords.longitude,
    });
}

export const getLatestLocation = async () => {
    return appApi.get(endpointPrefix + '/latest');
}

export const getLatestLocations = async () => {
    return appApi.get(endpointPrefix + '/latests');
}

export const getLocationQR = async (clientId: bigint) => {
    const coordinates = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 0
    });
    return appApi.get(endpointPrefix + '/' + clientId + '/get-qr', {
        params: {
            latitude: coordinates.coords.latitude,
            longitude: coordinates.coords.longitude,
        }
    });
}

export const postReadQrCode = async (data: LocationQrData) => {
    return appApi.post(endpointPrefix + '/read-qr', {
        date: data.time,
        client: data.client,
        qrFromUser: data.user,
        latitude: data.latitude,
        longitude: data.longitude,
    });
}

export const validate = async () => {
    const coordinates = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 0
    });
    return appApi.get(endpointPrefix + '/validate', {
        params: {
            latitude: coordinates.coords.latitude,
            longitude: coordinates.coords.longitude,
        }
    });
}

export const leave = async (endDate?: string | null) => {
    const coordinates = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 0
    });
    return appApi.post(endpointPrefix + '/leave', {
        latitude: coordinates.coords.latitude,
        longitude: coordinates.coords.longitude,
        endAt: endDate
    });
}